import React, { useEffect, useMemo } from 'react'
import sharedClasses from '../../Auth/signup.module.css'
import classes from '../../Auth/SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../../assets/images/beneficiary-invite-image.jpg'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../../components/Button/Button'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { BeneficiaryTop } from './BeneficiarySignUp'
import useCompanyLogo from '../../../hooks/useCompanyLogo'
import Loading from '../../../components/loaders/Loading'
import { Redirect } from 'react-router'
import { authSelectors, authActions } from '../../../redux/authSlice'
import { getParentRoute } from '../../../util/functions'
import notification from '../../../components/Notification/notification'
import { sendResetLink, resetPassword } from '../../../api/authApi'
import * as yup from 'yup'

const resetPasswordSchema = yup.object({
    password: yup.string().required('Please input a new password'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password')], 'Passwords do not match')
        .required('Please input your new password again'),
})

function BeneficiaryResetPassword({ history, match, location }) {
    const dispatch = useDispatch()
    const hasError = useSelector(authSelectors.getHasErrorState)
    const errorMessage = useSelector(authSelectors.getErrorMessageState)
    const success = useSelector(authSelectors.getSuccessState)
    const [token] = useMemo(() => {
        const params = new URLSearchParams(location.search)
        return [params.get('token')]
    }, [location.search])

    const path = getParentRoute(location.pathname)

    const submitForm = async ({ password }) => {
        const [dismiss] = await notification.loading({
            title: 'Submitting...',
        })
        await dispatch(
            resetPassword({
                password,
                token,
            })
        )
        dismiss()
    }

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    useEffect(() => {
        if (success) {
            notification.success({
                title: 'Success',
                description: 'Password reset successfully',
            })
            dispatch(authActions.resetState())
            history.push(`${path}/sign-in`)
        }
    }, [success, history, path, dispatch])

    const { domainName } = match.params

    const logoProps = useCompanyLogo(domainName)

    if (!token) {
        return <Redirect to={`${path}/forgot-password`} />
    }

    if (logoProps.isFetching) {
        return <Loading />
    }

    if (logoProps.has404Error) {
        return (
            <Redirect
                to={{
                    pathname: '/app/404',
                    state: { finalDestination: true },
                }}
            />
        )
    }

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                }}
                validationSchema={resetPasswordSchema}
                onSubmit={submitForm}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <BeneficiaryTop logoProps={logoProps} />
                        <h1 className={sharedClasses.formHeader}>
                            Reset Password
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                type="password"
                                placeholder={'New Password'}
                                name={'password'}
                            />
                            <ValidatedLoginInput
                                className={classes.input}
                                type="password"
                                placeholder={'Confirm New Password'}
                                name={'confirmPassword'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            onClick={handleSubmit}
                        >
                            Reset Password
                            <ButtonIcon
                                icon={
                                    <ArrowRight
                                        className={sharedClasses.formButtonIcon}
                                    />
                                }
                            />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Back to{' '}
                            <Link
                                to={`${path}/sign-in`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt=""
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default BeneficiaryResetPassword
